import * as React from 'react';

import { BtiErrorDataPopupContainer } from '../bti_error_data_popup/container';
import * as styles from './index.css';
import { trackErrorClick } from './tracking';

export interface IBtiCommercialFooterDispachProps {
  openBtiDataErrorPopup(): void;
}

export interface IBtiCommercialFooterStoreProps {
  isVisible: boolean;
}

export function BtiCommercialFooter(props: IBtiCommercialFooterStoreProps & IBtiCommercialFooterDispachProps) {
  return props.isVisible ? (
    <div className={styles['footer']}>
      <BtiErrorDataPopupContainer />
      <div className={styles['info']}>По данным аналитического центра CIAN</div>
      <div
        className={styles['error']}
        onClick={() => {
          trackErrorClick();
          props.openBtiDataErrorPopup();
        }}
      >
        Ошибка в данных о доме или районе?
      </div>
    </div>
  ) : null;
}
